<template>
  <div id="basicLayout">
    <a-layout style="min-height: 100vh">
      <a-layout-header class="header">
        <GlobalHeader />
      </a-layout-header>
      <a-layout-content class="content">
        <router-view />
      </a-layout-content>
      <a-layout-footer class="footer">
        <a target="_blank"> by zxq </a>
      </a-layout-footer>
    </a-layout>
  </div>
</template>
<script setup lang="ts">
import GlobalHeader from "@/components/GlobalHeader.vue";
</script>
<style scoped>
#basicLayout {
}
/* 头部样式与底部间距和阴影效果 */
#basicLayout .header {
  margin-bottom: 10px;
  box-shadow: #eee 1px 1px 5px;
}

#basicLayout .content {
  box-sizing: border-box;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 20px;
  padding: 20px;
  /* 背景色使用变量，移除固定的渐变，以适配暗黑模式 */
  background-color: var(--color-bg-2);
  border-radius: 10px; /* 可选：增加圆角使其更美观 */
  //background: linear-gradient(to right, #fefefe, #fff);
}
#basicLayout .footer {
  background: #efefefef;
  text-align: center;
  padding: 10px;
}
</style>
